<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <router-link v-if="item" :to="{ name: 'EXSBOrderList' }" class="mb-1 btn btn-sm btn-default float-right">{{ $t('buttons.backToList') }}</router-link>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <Loader v-if="isLoading" />
            <EXSBOrderForm v-else
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :errors="violations"
              :initial-values="retrieved" />
          </b-card>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBOrderForm from './Form.vue'
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  components: {
    EXSBOrderForm,
    Loader
  },

  data () {
    return {
      item: {},
      prevRoute: null
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsborder/update/isLoading',
      error: 'exsborder/update/error',
      deleteError: 'exsborder/del/error',
      deleteLoading: 'exsborder/del/isLoading',
      created: 'exsborder/create/created',
      deleted: 'exsborder/del/deleted',
      retrieved: 'exsborder/update/retrieved',
      updated: 'exsborder/update/updated',
      violations: 'exsborder/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBOrderList' })
    },
    updated: function (deleted) {
      if (!deleted) {
        return
      }
      if (this.prevRoute.name === 'EXSBOrderList') {
        this.$router.push({ name: 'EXSBOrderList' })
      } else if (this.prevRoute.name === 'EXCMCaseShow') {
        this.$router.go(-1)
      }
    }
  },

  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsborder/create/reset',
      deleteItem: 'exsborder/del/del',
      delReset: 'exsborder/del/reset',
      retrieve: 'exsborder/update/retrieve',
      updateReset: 'exsborder/update/reset',
      update: 'exsborder/update/update',
      updateRetrieved: 'exsborder/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsborder ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
